module.exports = __webpack_public_path__ + "img/box-right.522c05be.png";